import type { ReactNode } from "react";

/**
 * Bloque de código del sistema (`sk-code`): texto tal cual, sin numerar
 * (para eso está CodeView). Es una región con nombre y enfocable porque
 * hace scroll horizontal: sin foco, el teclado no podría desplazarla.
 */
export function CodeBlock({ label, children }: { label: string; children: ReactNode }) {
  return <div className="sk-code" tabIndex={0} role="region" aria-label={label}>{children}</div>;
}
